module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-tab"
  }, [_c('div', {
    staticClass: "div-wrap",
    attrs: {
      "id": "scroll-tab"
    }
  }, [_c('div', {
    staticClass: "scroll-fix"
  }, [_c('div', {
    staticClass: "item active",
    attrs: {
      "data-type": "detail",
      "bindtap": "switchTab"
    }
  }, [_vm._v("商品详情")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083f12d6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/detail-tab.vue
// module id = 1033
// module chunks = 2